var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":"36px"}},[_c('img',{attrs:{"alt":"Avatar","src":_vm.user.avatar || 'icons/user.png'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }